<app-breadcrumb [title]="'Преглед'" [items]="['Каса']" [active_item]="'Преглед'"></app-breadcrumb>
<ng-container *ngIf="isLoaded">
  <div style="display: flex; justify-content: end;">
    <button  type="button" style="margin-right: 10px;" class="btn btn-success" (click)="onImportFromEPayments()"><i class="bi bi-cloud-download"></i> Импорт от ePayments</button>
    <button  type="button" style="margin-right: 10px;" class="btn btn-primary" (click)="onAdd()"><i class="bi bi-check-circle"></i> Добави Сметка</button>
    <button [disabled]="!selectedService"  type="button" style="margin-right: 10px;" class="btn btn-warning" (click)="onUpdate()"><i class="bi bi-exclamation-triangle"></i> Редактирай</button>
  </div>
  <table class="table table-hover">
    <thead>
      <tr>
        <th scope="col">Наименование</th>
        <th scope="col">ИБАН</th>
        <th scope="col">БИК</th>
        <th scope="col">Тип</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let service of services" [ngClass]="!isSelected(service)?'':'selected-cell'" (click)="onSelected(service)">
        <td>{{service.title}}</td>
        <td>{{service.iban}}</td>
        <td>{{service.bic}}</td>
        <td>{{GetBankType(service.status)}}</td>
      </tr>

    </tbody>
  </table>
</ng-container>
<ng-container *ngIf="!isLoaded">
<div style="text-align: center;">
  <div class="spinner-grow spinner-grow-sm" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 30px; height: 30px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 40px; height: 40px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 50px; height: 50px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
</ng-container>
